export default __webpack_public_path__ + "static/media/sweet4.773ebfef.jpg";